module.exports = __webpack_public_path__ + "static/media/client.a4db2bc6.jpg";